/*
Core property entity with business logic
*/

export class Property {
  constructor(
    public readonly id: string,
    public readonly address: string | null,
    public readonly beds: number | null,
    public readonly baths: number | null,
    public readonly sqft: number | null,
    public readonly listPrice: number | null,
    public readonly listPricePerSqft: number | null,
    public readonly equity: number | null,
    public readonly daysOnMarket: number | null,
    public readonly imgUrl: string | null,
    public readonly status: string | null,
    public readonly daysSinceSold: number | null,
  ) {
    if (!id) throw new Error('Property requires id');
  }
}
